import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';
import IdlingConsumptionMotiveSelect from '../../../../common/forms/select/IdlingConsumptionMotiveSelect';
import { DEFAULT_QUERY_GET_ALL } from '../../../../../config/queries';
import { isRequired, validateNumber } from '../../../../../utils/validators';
import {
  clearIdlingConsumptionMotives,
  getIdlingConsumptionMotives,
} from '../../../../../actions';

const IdlingConsumptionForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  dispatchGetIdlingConsumptionMotives,
  dispatchClearIdlingConsumptionMotives,
}) => {
  useEffect(() => {
    dispatchGetIdlingConsumptionMotives(DEFAULT_QUERY_GET_ALL);

    return () => {
      dispatchClearIdlingConsumptionMotives();
    };
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit(handleProcess)}>
        <FormGroup row>
          <FormItem label="Motivo" required>
            <Field
              name="idlingConsumptionMotiveId"
              component={IdlingConsumptionMotiveSelect}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Tiempo (Minutos)" required>
            <Field
              name="idlingConsumptionTime"
              component={TextInput}
              type="text"
              placeholder="Tiempo (Minutos)"
              validate={[isRequired, validateNumber]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Galones Autorizados" required>
            <Field
              name="idlingConsumptionNumberOfGallon"
              component={TextInput}
              type="text"
              placeholder="Galones"
              validate={[isRequired, validateNumber]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Observaciones" required>
            <Field
              name="observation"
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>

        <FormFooter>
          <Button color="danger" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

IdlingConsumptionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  dispatchGetIdlingConsumptionMotives: PropTypes.func.isRequired,
  dispatchClearIdlingConsumptionMotives: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchChange: change,
  dispatchGetIdlingConsumptionMotives: getIdlingConsumptionMotives,
  dispatchClearIdlingConsumptionMotives: clearIdlingConsumptionMotives,
};

const formComponent = reduxForm({
  form: 'IdlingConsumptionForm',
})(IdlingConsumptionForm);

export default connect(null, mapDispatchToProps)(formComponent);
